import { render, staticRenderFns } from "./GroupsAndExtensions.vue?vue&type=template&id=39dff682&"
import script from "./GroupsAndExtensions.vue?vue&type=script&lang=js&"
export * from "./GroupsAndExtensions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports